import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, Renderer2, ViewChild} from '@angular/core';
import {AssertionUtils, TranslateService} from '@vdw/angular-component-library';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-production-schedule-item-in-path-group-repeat-indicator-new]',
  templateUrl: './production-schedule-item-in-path-group-repeat-indicator-new.component.html',
  styleUrls: ['./production-schedule-item-in-path-group-repeat-indicator-new.component.scss']
})
export class ProductionScheduleItemInPathGroupRepeatIndicatorNewComponent implements AfterViewInit, OnChanges {
  @Input() public quantity: number;
  @Input() public productionScheduleItemMultiplier: number;
  @Input() public drawingWidth: number;

  @ViewChild('repeatIndicatorLabel') public repeatIndicatorLabel: ElementRef;
  @ViewChild('repeatIndicatorLabelContainer') public repeatIndicatorLabelContainer: ElementRef;

  public readonly REPEAT_INDICATOR_LABEL_CONTAINER_PADDING: number = 8;

  public static minimumAllowedHeight: number = 54;
  public repeatIndicatorLabelContainerXPosition: number = 0;
  public canShowRepeatIndicatorLabel: boolean = true;

  public constructor(
    private readonly renderer: Renderer2,
    private readonly translate: TranslateService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngAfterViewInit(): void {
    this.setRepeatIndicatorLabelAttributes();
    this.setCanShowRepeatIndicatorLabel();
    this.changeDetectorRef.detectChanges();
  }

  public ngOnChanges(): void {
    this.setRepeatIndicatorLabelAttributes();
  }

  public getQuantityText(): string {
    return `${this.productionScheduleItemMultiplier} x ${this.quantity} ${this.translate.instant('PRODUCTION_ORDER.PHASES.DESIGNS')}`.toLowerCase();
  }

  public setCanShowRepeatIndicatorLabel(): void {
    if (AssertionUtils.isNullOrUndefined(this.repeatIndicatorLabel)) {
      return;
    }

    const textWidth = this.repeatIndicatorLabel.nativeElement.getBBox().width;
    const containerWidth = textWidth + this.REPEAT_INDICATOR_LABEL_CONTAINER_PADDING * 2;
    this.canShowRepeatIndicatorLabel = containerWidth < this.drawingWidth;
  }

  private setRepeatIndicatorLabelAttributes(): void {
    if (AssertionUtils.isNullOrUndefined(this.repeatIndicatorLabel) || AssertionUtils.isNullOrUndefined(this.repeatIndicatorLabelContainer)) {
      return;
    }

    const textWidth = this.repeatIndicatorLabel.nativeElement.getBBox().width;
    const containerWidth = textWidth + this.REPEAT_INDICATOR_LABEL_CONTAINER_PADDING * 2;

    this.renderer.setAttribute(this.repeatIndicatorLabelContainer.nativeElement, 'width', `${containerWidth}px`);
    this.renderer.setAttribute(this.repeatIndicatorLabelContainer.nativeElement, 'x', `calc(100% - ${containerWidth + this.REPEAT_INDICATOR_LABEL_CONTAINER_PADDING}px)`);
  }
}
